<template>
    <div class="sign_up_dialog">
        <InputBar :use_phone="use_phone"
                  @signOnInfo="update_u_p"
                  @emit_login="regist(registArgs)"
        ></InputBar>
        <div v-if="use_phone" class="input-group input_group" @keyup.enter="regist(registArgs)">
            <el-input placeholder="请输入短信验证码" v-model="verification_code"></el-input>
            <el-link v-if="countdown>0" style="position: absolute;right: 0px;top: 12px;" disabled>{{countdown}}秒后可重发</el-link>
            <el-link v-else style="position: absolute;right: 0px;top: 10px;" @click="send_verification_xyz" type="primary" :underline="false">获取短信验证码</el-link>
        </div>
        <!--<div class="custom_control_div">-->
            <!--<div>-->
                <!--&lt;!&ndash;<a v-if="use_phone" @click="change_use_phone" href="javascript:;">使用邮箱注册</a>&ndash;&gt;-->
                <!--&lt;!&ndash;<a v-else @click="change_use_phone" href="javascript:;">使用手机注册</a>&ndash;&gt;-->
            <!--</div>-->
            <!--<div>-->
                <!--<el-link v-if="countdown>0" disabled>{{countdown}}秒后可重发</el-link>-->
                <!--<el-link v-else @click="send_verification_xyz" type="primary" :underline="false">获取短信验证码</el-link>-->
            <!--</div>-->
        <!--</div>-->
        <a class="enter_button" href="javascript:;" @click="regist(registArgs)">加入成长之路</a>
    </div>
</template>

<script type="text/javascript">
    import loginApi from '@/api/login/login.js'
    import InputBar from './sub_components/input_bar.vue'
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                // username: ,password:
                base_regist_args: {},
                checked: '',
                use_phone: true,
                verification_code: '',
                countdown: 0,
            }
        },
        components: {
            InputBar
        },
        computed: {
            registArgs: function () {
                let args = {...this.base_regist_args}
                args.use_phone = this.use_phone
                args.verification_code = this.verification_code
                return args
            },
        },
        methods: {
            ...mapActions({
                regist_info: 'loginState/to_regist_info',
                change_warning_message: 'warningBar/change_message',
                change_warning_bar_style_class: 'warningBar/change_warning_bar_style_class'
            }),
            regist: function (registArgs) {
                this.regist_info(registArgs)
            },
            update_u_p: function (data) {
                this.base_regist_args = data
            },
            change_use_phone() {
                this.use_phone = !this.use_phone
            },

            send_verification_xyz() {
                let args = {
                    'type': 'regist',
                    'phone': this.registArgs.login,
                }
                loginApi.send_verification_xyz(args).then(res => {
                    console.log(res)
                    let data = JSON.parse(res.data.result)
                    this.change_warning_message(data.message);
                    if (data.code === 'success') {
                        this.change_warning_bar_style_class('success');
                        var that = this
                        that.countdown = 60;
                        var interval = setInterval(function () {
                            that.countdown -= 1;
                            if (that.countdown === 0) {
                                clearInterval(interval);
                            }
                        }, 1000);
                    } else {
                        this.change_warning_bar_style_class('alert');
                    }
                })
            },

        },
    }
</script>

<style type="text/css" scoped>
    >>> .el-input__inner {
        border: none;
    }

    .input_group {
        display: flex;
        border-bottom: 1px solid #eee;
        margin-bottom: 15px;
    }

    .custom_control_div {
        display: flex;
        justify-content: space-between;
        /*align-items: center;*/
        color: #999;
        font-size: 14px;
    }

    .enter_button {
        display: block;
        width: 100%;
        color: #fff;
        margin-top: 30px;
        background: #6CF;
        padding: 6px 12px;
        font-size: 14px;
        text-align: center;
        border: 1px solid #6CF;
        border-radius: 20px;
    }

    .enter_button:hover {
        background: #6CE;
        color: #fff;
    }

</style>
